import React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AgencyList from './agency-list';

function AgencyManager() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AgencyList />
    </DashboardLayout>
  );
}

export default AgencyManager;
